import { motion } from "framer-motion";
import { CHAPTERS } from "../../lib/content";

export default function Manifesto() {
  return (
    <section className="relative py-28 md:py-40" data-testid="manifesto-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <div className="tag-glass"><span className="dot" /> The manifesto · three chapters</div>
          <h2 className="font-display text-white text-4xl md:text-6xl leading-[1.02] tracking-tight mt-6">
            Advertising is a rental market. <br />
            <span className="italic-accent text-white/72">We built the property instead.</span>
          </h2>
        </motion.div>

        <div className="mt-20 space-y-16 md:space-y-24">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.05 }}
              className={`grid grid-cols-12 gap-6 items-start ${i % 2 ? "md:pl-24" : ""}`}
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <div className="col-span-12 md:col-span-3">
                <div className="font-mono text-white/40 text-sm uppercase tracking-[0.22em]">Chapter</div>
                <div className="font-display text-[18vw] md:text-[7vw] leading-none tracking-tight text-white/90">
                  {c.n}
                </div>
              </div>
              <div className="col-span-12 md:col-span-8 md:pt-6">
                <h3 className="font-display text-3xl md:text-4xl leading-[1.1] tracking-tight text-white">
                  {c.title}
                </h3>
                <p className="mt-6 text-white/75 text-base md:text-lg max-w-2xl leading-relaxed">
                  {c.body}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
